import { Loader2 } from "lucide-react";
import { useTranslations } from "next-intl";

export default function GoogleAuthLoadingScreen() {
  const t = useTranslations("Loading");

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center w-[100dvw] h-[100dvh] bg-background/95 backdrop-blur-sm z-50">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-lg font-medium text-muted-foreground">
          {t("authenticatingWithGoogle")}
        </p>
      </div>
    </div>
  );
}
